var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImnooSettingsIcon = function SvgImnooSettingsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.882 3C18.727 3 8.955 5.753 8.955 5.753c-.315.106-.525.318-.525.635v11.86C8.43 21 9.585 21 12.738 21h10.401c.21 0 .42-.212.42-.424V6.813C23.665 4.694 21.985 3 19.883 3m-1.05 12.812c0 .423-.316.635-.632.635h-4.307c-.316 0-.63-.212-.63-.53v-5.823c0-.318.209-.53.524-.635 1.472-.424 3.047-.847 4.309-1.06.314-.105.735.107.84.53v.106z",
    clipRule: "evenodd"
  })));
};
export default SvgImnooSettingsIcon;